import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { puedeVerPanelAdmin } from '../utils/permisos'

export const AdminRoute = () => {
  const { session } = useAuth()

  return puedeVerPanelAdmin(session)
    ? <Outlet />
    : <Navigate to="/" replace />
}
